import {
  Badge,
  Banner,
  BlockStack,
  InlineStack,
  Scrollable,
  Text,
} from "@shopify/polaris"
import { useTranslation } from "react-i18next"

import type { SyncPreview } from "../../typings/types"

const SyncPreviewList = ({
  preview,
  refreshed,
}: {
  preview: SyncPreview
  refreshed: boolean
}) => {
  const { t } = useTranslation("home")

  return (
    <BlockStack gap="300">
      {refreshed && (
        <Banner tone="warning">{t("home:sync.preview.refreshed")}</Banner>
      )}
      <Text as="p" fontWeight="semibold">
        {t("home:sync.preview.total", { total: preview.count })}
      </Text>
      <Scrollable shadow style={{ maxHeight: "320px" }}>
        <BlockStack gap="200">
          {preview.articles.map(({ title, blog, isNew }, index) => (
            <InlineStack
              key={index}
              gap="200"
              align="space-between"
              blockAlign="center"
              wrap={false}
            >
              <BlockStack>
                <Text as="span">{title}</Text>
                <Text as="span" tone="subdued" variant="bodySm">
                  {blog}
                </Text>
              </BlockStack>
              <Badge tone={isNew ? "success" : "info"}>
                {t(
                  isNew ? "home:sync.preview.new" : "home:sync.preview.update"
                )}
              </Badge>
            </InlineStack>
          ))}
        </BlockStack>
      </Scrollable>
      <Text as="p">
        {t("home:sync.preview.cost", {
          price: `$${preview.price.toFixed(2)}`,
        })}
      </Text>
    </BlockStack>
  )
}

export default SyncPreviewList
